// extracted by mini-css-extract-plugin
export default {"tabBar__container":"TabBar_tabBar__container__N+67A","tabBar__itemContainer":"TabBar_tabBar__itemContainer__rmdlr"};